import type { ApiMethodBase } from '@process-advisor/process-miner/api/types';
import { setDetailSource as setDetailSourceDiagram} from '@process-advisor/process-miner/processMiner/processMiner';

export type Props = ApiMethodBase & {
    source: string;
};

export const setDetailSource = ({
    source,
}: Props) => {
    setDetailSourceDiagram({source});
};



